<template>
  <div class="grid mt-8 gap-4 grid-cols-5">
    <div v-for="(title, icon) in icons" :key="icon" class="text-sm flex items-center">
      <Icon :name="icon" width="30" height="30" />
      <span class="ml-2 block text-center">{{ title }}</span>
    </div>
  </div>
</template>

<script>
import Icon from "@/Components/UI/Icons/Icon.vue";

export default {
  components: {
    Icon,
  },
  data() {
    return {
      icons: {
        edit: 'Editar',
        visualizar: 'Visualizar',
        sucesso: 'Sucesso',
        upload: 'Upload',
        slider: 'Slider',
        setaEsquerda: 'Seta Esquerda',
        setaDireita: 'Seta Direita',
        redimensionar: 'Redimensionar',
        redeSocial: 'SocialMedia',
        perfil: 'Perfil',
        notificacao: 'Notificacao',
        menuLogado: 'MenuLogado',
        loader: 'Loader',
        linkExterno: 'LinkExterno',
        fechar: 'Fechar',
        erro: 'Erro',
        editar: 'Editar',
        curtir: 'Curtir',
        chevronP: 'Chevron',
        chatRetratil: 'ChatRetratil',
        snapchat: 'Snapchat',
        telegram: 'Telegram',
        whatsapp: 'Whatsapp',
        instagram: 'Instagram',
        linkdin: 'Linkdin',
        youtube: 'Youtube',
        tiktok: 'Tiktok',
        twitter: 'Twitter',
        facebook : 'Facebook',
        twitch: 'Twitch',
        Baixar: 'Baixar',
      },
    };
  },
};
</script>
